import * as addressService from "@hub/simulator/src/services/address.service"
export default {
  fillAddress({ commit }, address) {
    commit("setAllAddress", address)
  },
  createComplement({ commit, state }, newComplement) {
    const newComplements = [...state.complements, newComplement]
    commit("setComplements", newComplements)
  },
  removeComplement({ commit, state }, indexComplement) {
    const newComplements = state.complements.filter(
      (complement, index) => index !== indexComplement
    )
    commit("setComplements", newComplements)
  },
  updateComplement({ commit, state }, newValuesComplement) {
    let newComplements = state.complements
    newComplements[newValuesComplement.index][newValuesComplement.key] =
      newValuesComplement.value
    commit("setComplements", newComplements)
  },
  async fetchAddressByUserPosition({ commit, getters }) {
    if (
      (!getters.getCurrentLatitude && !getters.getCurrentLongitude) ||
      getters.getHasMadeCepFromCurrentLocationRequest
    ) {
      return
    }

    const params = {
      latitude: getters.getCurrentLatitude,
      longitude: getters.getCurrentLongitude
    }

    try {
      const { data } = await addressService.fetchAddressByUserPosition(params)

      if (data) {
        commit("setCepForCurrentLocation", data?.address?.postcode)
        return
      }
    } catch (error) {
      console.error(error)
    } finally {
      commit("setHasMadeCepFromCurrentLocationRequest", true)
    }
  }
}
